import type { JSXChild, JSXProps } from 'engine/index';

export function SelectorButton(props: JSXProps, children: JSXChild[]) {
	return (
		<button
			{...props}
			class={
				(props.class ?? '') +
				' inline-flex cursor-pointer items-baseline justify-center gap-3 rounded-md border border-gray-200 bg-gray-100 p-3 text-gray-800 transition-transform focus-visible:scale-105'
			}
		>
			{children}
		</button>
	);
}
